import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import i18n from 'i18n-react';

import type { Amenity } from 'helpers/getListingAmenities';

import { decodeHtmlEntities } from '../../helpers/decodeHtmlEntities';
import c from './_profileAmenities.module.scss';

export interface ProfileAmenitiesProps {
  typeName: string | null;
  numberOfRooms?: number | null;
  amenities: Amenity[];
}

export function ProfileAmenities({ typeName, numberOfRooms, amenities }: ProfileAmenitiesProps) {
  // The API stores a blank room count as 0, so 0 is treated as "not set".
  const hasRooms = Number(numberOfRooms) > 0;
  const hasTypeName = Boolean(typeName?.trim());

  return (
    <div className="profile-amenities">
      {(hasTypeName || hasRooms) && (
        <div className={clsx('profile-amenities__group', c.group)}>
          <div className={clsx('profile-amenities__title', c.title)}>
            {i18n.translate('directoryProfileView.accommodationType')}
          </div>
          {hasTypeName && <div>{decodeHtmlEntities(typeName)}</div>}
          {hasRooms && (
            <div>
              {i18n.translate('directoryProfileView.amenitiesNumberOfRooms')}
              {numberOfRooms}
            </div>
          )}
        </div>
      )}

      <div className={clsx('profile-amenities__group', c.group)}>
        <div className={clsx('profile-amenities__title', c.title)}>
          {i18n.translate('directoryProfileView.amenitiesTitle')}
        </div>
        <div className={clsx('profile-amenities__grid', c.grid)}>
          {amenities.map(({ column, label }) => {
            return (
              <div className={clsx('profile-amenities__item', c.item)} key={column}>
                <FontAwesomeIcon icon={['fas', 'check-square']} className={clsx('profile-amenities__icon', c.icon)} />{' '}
                {label}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
